export enum EImagingMode {
  Unknown = 0,
  Manual = 1,
  Automatic = 2,
}